/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,Switch,
  HashRouter,
} from "react-router-dom";
import App from "../InitialPage/App";
// import config from "config";

import 'bootstrap/dist/css/bootstrap.min.css';
import "../assets/js/bootstrap.bundle.min.js";
// import "../assets/css/font-awesome.min.css";
import "../assets/css/style.css";
import "alertifyjs/build/css/alertify.css";


const MainApp = () => {

const config = '/'
  return(
    <Router basename={`${config}`}>
    <Switch>
      <Route path="/" component={App} />
    </Switch>
  </Router>
  )
  }

export default MainApp;
